import ReactDOM from 'react-dom';

var Portal = function Portal(_a) {
  var children = _a.children,
      _b = _a.target,
      target = _b === void 0 ? document.body : _b;
  return ReactDOM.createPortal(children, target);
};

export default Portal;

try {
  // @ts-ignore
  Portal.__docgenInfo = {
    "description": "",
    "displayName": "Portal",
    "props": {
      "target": {
        "defaultValue": null,
        "description": "",
        "name": "target",
        "required": false,
        "type": {
          "name": "Element | undefined"
        }
      }
    }
  };
} catch (__react_docgen_typescript_loader_error) {}